export default __webpack_public_path__ + "static/media/bg-header.d56ebc91.jpg";